import React from "react";
import { motion } from "framer-motion";
import { inView } from "./utils";

const SectionHead = ({ eyebrow, title, lede, align = "left" }) => (
  <motion.header
    className={`au-head au-head--${align}`}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={inView}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
  >
    {eyebrow && <span className="au-eyebrow">{eyebrow}</span>}
    <h2 className="au-h2">{title}</h2>
    {lede && <p className="au-lede">{lede}</p>}
  </motion.header>
);

export default SectionHead;